<template>
  <el-dialog
    title="新增或修改商户"
    :visible.sync="merchantVisible"
    :lock-scroll="false"
    :close-on-click-modal="false"
    width="40%"
    @close="resetForm"
  >
    <el-form
      label-width="100px"
      size="mini"
      ref="merchant"
      :model="formData"
      :rules="rules"
    >
      <el-form-item label="商家名称" prop="name">
        <el-input v-model="formData.name"></el-input>
      </el-form-item>
      <el-form-item label="商家地址">
        <el-input v-model="formData.address"></el-input>
      </el-form-item>

      <el-form-item label="商家密码" v-if="!formData.id">
        <el-input v-model="formData.password" type="password"></el-input>
        <span class="promptText">默认密码0123456</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmitBtn">确定</el-button>
      <el-button @click="onCancelBtn">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { updateShopUser } from "@/api/url";
export default {
  name: "merchant-update",
  props: {
    merchantVisible: Boolean,
    groupId: String,
    merchant:Object,
  },
  data() {
    return {
      formData: {},
      rules: {},
    };
  },
  watch:{
    merchant:{
      handler:function(val,oldVal){
        val?this.formData=JSON.parse(JSON.stringify(val)):this.formData=this.initForm();
      },
      deep:true,
      immidiate:true
    }
  },
  methods: {
    onSubmitBtn() {
      if (!this.groupId) return;
      const reqType=this.formData?.id?this.$putRequest:this.$postRequest
      this.$refs.merchant.validate((valid) => {
        if (!valid) return;
        reqType(!this.formData?.id?updateShopUser():`${updateShopUser()}/${this.formData?.id}`, {
        ...this.formData
        }).then((data) => {
          this.$notify({
            type: data.status != 200 ? "warning" : "success",
            title: data.status != 200 ? "失败" : "成功",
            message: data.status != 200 ? data.message : "添加或修改成功！",
          });
          this.$parent.merchantUpdateCallback();
        });
      });
    },
    onCancelBtn() {
      this.$parent.merchantUpdateCallback();
    },
    resetForm() {
      this.formData = this.initForm();
    },
    initForm() {
      return {
        parkingId: this.groupId,
        name: null,
        password: null,
        address: null,
        mchType: "platform",
      };
    },
  },
};
</script>
<style></style>
